
















































import StringUtil from '@/core/services/StringUtil';
import { UUIDUtil } from '@/core/services/uuid.util';
import { Contact } from '@/model/contact.model';
import { Family } from '@/model/family.model';
import { Reporting } from '@/model/reporting.model';
import { StoreActions, StoreMutations } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ReportingEmailAll extends Vue {
  data() {
    return {
      fullEmail: false,
    };
  }

  get contacts() {
    return StringUtil.dedupe(
      this.$store.state.families.reduce((acc: string[], family: Family) => {
        return [
          ...acc,
          ...StringUtil.dedupe(family.contacts || [], 'email')
            .filter((c) => c.email)
            .map((c) => ({ ...c, uuid: UUIDUtil.uuid4() })),
        ];
      }, []),
      'email',
    );
  }

  mounted() {
    this.$store.dispatch(StoreActions.GetFamilies);
  }
}
